import { render, staticRenderFns } from "./Splide.vue?vue&type=template&id=776da492"
import script from "./Splide.vue?vue&type=script&lang=js"
export * from "./Splide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports